export type ToastType = 'info' | 'success' | 'error'

export type ToastAction = {
  label: string
  onClick: () => void
}

export type ToastOptions = {
  type: ToastType
  message: string
  action?: ToastAction
  dismissable?: boolean
  duration?: number
}

export type ToastEntry = ToastOptions & { id: string }

type ToastListener = (toasts: ToastEntry[]) => void

let activeToasts: ToastEntry[] = []
const listeners = new Set<ToastListener>()
const dismissTimers = new Map<string, ReturnType<typeof setTimeout>>()

function emit() {
  const snapshot = [...activeToasts]
  listeners.forEach((listener) => listener(snapshot))
}

export function showToast(options: ToastOptions) {
  const id = crypto.randomUUID()
  const entry: ToastEntry = { ...options, id }
  activeToasts = [...activeToasts, entry]
  emit()

  const duration = options.duration ?? 5000
  if (duration > 0) {
    const timer = setTimeout(() => dismissToast(id), duration)
    dismissTimers.set(id, timer)
  }
}

export function dismissToast(id: string) {
  const timer = dismissTimers.get(id)
  if (timer) {
    clearTimeout(timer)
    dismissTimers.delete(id)
  }
  activeToasts = activeToasts.filter((toast) => toast.id !== id)
  emit()
}

export function subscribeToasts(listener: ToastListener): () => void {
  listeners.add(listener)
  listener([...activeToasts])
  return () => {
    listeners.delete(listener)
  }
}
